import dayjs from 'dayjs';
import React from 'react';
import DateRangePicker from '../../elements/DateRangePicker';
import Select from '../../fields/SelectBox/Select';
import IconUpDownArrow from '../../icons/IconUpDownArrow';

export const defaultDateRange = [
  dayjs().subtract(6, 'day').toDate(),
  dayjs().toDate(),
];
export const initialValues = {
  date: defaultDateRange,
  status: '',
};


export const Fields = ({
  values = initialValues,
  handleChangeValues,
  dropdownData,
  setValueDate,
  valueDate
}) => {
  const datePickerProps = {
    dropdownPosition: 'bottom-start',
    allowSingleDateInRange: true,
    valueFormat: 'DD MMM YYYY',
    locale: 'id',
    placeholder: 'Pilih tanggal',
    rightSection: <IconUpDownArrow />,
  };
  return[
    {
      label: 'Tanggal',
      component: (
        <DateRangePicker
          inputProps={datePickerProps}
          maxDate={dayjs().toDate()}
          minDate={dayjs().subtract(1, 'year').toDate()}
          onChange={(value) => {
            setValueDate(value);
            if (Object.values(value).every((item) => Boolean(item))) {
              handleChangeValues('date', value);
            }
          }}
          type="range"
          value={valueDate}
        />
      )
    },
    {
      label: 'Status Data',
      component: (
        <Select
          data={dropdownData.status}
          eventName="status-data"
          hideLabel
          name="status"
          onChangeSelect={(value) =>
            handleChangeValues('status', value)
          }
          placeholder="Semua Status"
          rightSection={<IconUpDownArrow />}
          valueForm={values.status}/>
      )
    }
  ];
};

